/**
 * This file should be treated as a legacy file that should only be modified when necessary.
 */

import 'lazysizes';
import lazySizes from 'lazysizes';
import Headroom from 'headroom.js';
import $ from 'jquery';
import 'slick-carousel';
import 'selectize';
import 'simplebar';
import 'magnific-popup';
import { collectQueries, cookie } from './utilities';
import './components/sticky-banner';

document.addEventListener('lazybeforeunveil', function(e){
  var bg = e.target.getAttribute('data-bg');
  if(bg){
      e.target.style.backgroundImage = 'url(' + bg + ')';
  }
});

const Mangrove = {
  init() {
    this.cache();
    this.events();
    this.selectify()
    this.sizeTimeline();
    this.initHeadroom();
    this.initStickyNav();
    this.initStickyForm();
    this.initStickyShare();
    this.initSlick();
    this.initPopup();
    this.initCareersFilter();
    this.initCaptureUTM();
    this.initAjax();
    this.removeSubmenus();
    this.pricingUX();
    this.initSliderIosPage();
    this.setPricingPageCtaParams();
    this.setHubSpotFormCountryDd();
    this.customEmailValidationHubSpot();
    this.forwardApprovedUrlParams();
    $('.page-template-report').length && this.reportMenuScroll();
    $('.page-template-thankyou').length && this.triggerPdfPownload();
  },
  cache() {
    this.$doc = $(document);
    this.$win = $(window);
    this.$html = $('html');
    this.$body = $('body');
    this.$mainWrap = $('main');
    this.$header = $('.js-header');
    this.$mobileNav = $('.js-mobile-nav');
    this.$hamburger = $('.js-hamburger');
    this.$search = $('#search-box');
    this.stickyFormTriggered = false
    this.video = {
      playing: false,
      shown: false,
      time: null
    }
    this.careerLocations = []
  },
  events() {
    const {toggleBannerOpen, addTouch} = this

    $(window).on('load', function() {
      if ( $(window).scrollTop() != 0 ) toggleBannerOpen(null, true)
      $('.home').length && $('.js-slider-home').addClass('loaded')
      $('.mobile-auto-play-trigger').length && addTouch($('.mobile-auto-play-trigger')[0]);
    })
    // this.$doc.on(
    //   'click',
    //   'a',
    //   event => this.openLinksInNewWindow(event)
    // )
    this.$doc.on(
      'click',
      '.js-hamburger',
      event => this.showMobileNav(event)
    );
    this.$doc.on(
      'mouseenter',
      '.nav--main > ul > li',
      event => this.openSubMenu(event)
    );
    this.$doc.on(
      'mouseover',
      'main, .nav--main .menu-item:not(.menu-item-has-children)',
      event => this.closeSubMenu(event)
    );
    this.$doc.on(
      'click',
      '.nav--mobile__inner > ul > li > a',
      event => this.openMobileNavDrawer(event)
    );
    // this.$doc.on(
    //   'click',
    //   '.nav--mobile__inner a.mobile-nav-close',
    //   event => this.closeMobileNavDrawer(event)
    // )
    this.$doc.on(
      'click',
      '.js-video-play',
      event => {
        $(event.currentTarget).addClass("hidden");
        $(event.currentTarget).next().get(0).play();
      }
    );
    this.$doc.on(
      'click',
      '.js-inner__poster, .js-play',
      event => this.showVideo(event)
    );
    this.$doc.on(
      'click',
      '.js-scroll-to',
      event => this.scrollToSection(event)
    );
    this.$doc.on(
      'input',
      '.seekbar__input',
      event => this.onSeek(event)
    );
    this.$doc.on(
      'touchend',
      '.mobile-auto-play-trigger',
      event => {
        $(event.currentTarget).next().get(0).play();
      }
    )
    this.$doc.on(
      'click',
      '.js-play polygon',
      event => this.onPlay(event)
    );
    this.$doc.on(
      'click',
      '.slide-nav',
      event => { event.preventDefault() }
    );
    this.$doc.on(
      'click',
      '.sub-menu--secondary__mobile .sub-menu--title a',
      event => this.handleSecondaryMobile(event)
    )
    this.$doc.on(
      'click',
      '.blog__form--close',
      event => this.closeBlogForm(event)
    )
    this.$win.on(
      'scroll',
      event => {
        // this.resetNav(event)
        this.initStickyNav(event)
        this.initStickyForm(event)
        this.initStickyShare(event)
        this.toggleBannerOpen(event)
        if ( $('.page-down-button').length ) this.initArrowScroll(event)
        if ( $('.header__scroll').length ) this.initTrackBlogScroll(event)
      }
    );
    this.$body.on(
      'click',
      event => this.resetNav(event)
    );
    this.$doc.on(
      'click',
      '.page-id-783 .hero',
      event => this.handleMiParrow(event)
    )
    this.$doc.on(
      'click',
      '.filter-location [type="checkbox"]',
      event => this.handleCareersFilter(event)
    )
    this.$doc.on(
      'click',
      '.js-webinar-modal',
      event => this.handleWebinarModal(event)
    )
    this.$doc.ready( e => {
      $('.post__search').on(
        'focus blur',
        event => this.toggleSearchExpand(event)
      )
    })
    this.$doc.on(
      'click',
      '.js-share',
      event => this.openShareWindow(event)
    );
    this.$doc.on(
      'click',
      '.promo-banner__close',
      event => this.closeBanner(event)
    )
    this.$doc.on(
      'click',
      '.pricing__matrix--toggle button',
      event => this.toggleSeeMoreMatrix(event)
    )
    this.$doc.on(
      'change',
      '.pricing__toggle [type="checkbox"]',
      event => this.togglePricing(event)
    )
    this.$doc.on(
      'click',
      '.feature-tabs__list a',
      event => this.handleFeatureTabsClick(event)
    )
    this.$doc.on(
      'click',
      '.js-interactive a',
      event => this.handleProductFeatureClick(event)
    )
    $('.home-hero__video video').on('loadeddata', function(e) {
      $(this).addClass('loaded')
    })
    $('.home-hero__video video').on('loadstart', function(e) {
      const video = this;
      setTimeout(function() {
        $(video).addClass('loaded')
      }, 1000)
    })
    $(window).resize(() => {
      this.sizeTimeline()
      this.handleSliderExtendedFns()
    })
    $('.card-categories span').not('.active').on('click', function(e) {
      $('.card-categories .active').removeClass('active');
      $(e.target).addClass('active');
      $('#cat_list').addClass('hide-card-category');
    })
  },
  addTouch(elm) {
    const touchStartOn = function(el, x, y) {
      let e;
      if (x == null) { x = 0; }
      if (y == null) { y = 0; }
      try {
        e = document.createEvent('TouchEvent');
        e.initTouchEvent("touchstart", true, true);
      } catch (err) {
        try {
          e = document.createEvent('UIEvent');
          e.initUIEvent("touchstart", true, true);
        } catch (error) {
          err = error;
          e = document.createEvent('Event');
          e.initEvent("touchstart", true, true);
        }
      }
      e.targetTouches = [{
        pageX: x,
        pageY: y
      }];
      return el.dispatchEvent(e);
    };

    const touchEndOn = function(el, x, y) {
      let e;
      if (x == null) { x = 0; }
      if (y == null) { y = 0; }
      try {
        e = document.createEvent('TouchEvent');
        e.initTouchEvent("touchend", true, true);
      } catch (err) {
        try {
          e = document.createEvent('UIEvent');
          e.initUIEvent("touchend", true, true);
        } catch (error) {
          err = error;
          e = document.createEvent('Event');
          e.initEvent("touchend", true, true);
        }
      }
      e.changedTouches = [{
        pageX: x,
        pageY: y
      }];
      return el.dispatchEvent(e);
    };

    touchStartOn(elm, 5, 5);
    touchEndOn(elm, 10, 10);
  },
  initArrowScroll() {
    let opacity = ($(window).scrollTop() / ($(window).height() ) );

    if ( $(window).width() >= 960 ) {
      $('.page-down-button').css({'opacity': (1 - opacity), 'visibility': opacity < 0 ? 'hidden' : 'visible'} )
    }
  },
  togglePricing(e) {

    if ( !e.target.checked ) {
      $('[data-package="analytics"]').not('.label').addClass('is-active')
      $('[data-package="analytics_attribution"]').not('.label').removeClass('is-active')
    } else {
      $('[data-package="analytics_attribution"]').not('.label').addClass('is-active')
      $('[data-package="analytics"]').not('.label').removeClass('is-active')
    }
  },
  initTrackBlogScroll(event) {
    var winScroll = document.body.scrollTop || document.documentElement.scrollTop;
    var height = document.documentElement.scrollHeight - document.documentElement.clientHeight;
    var scrolled = (winScroll / height) * 100;
    document.querySelector(".header__progress").style.width = scrolled + "%";
  },
  initCaptureUTM() {
    const formIds = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 13];

    formIds.forEach(function(elm) {
      collectQueries(`#gform_${elm}`);
    })
  },
  closeBlogForm(event) {
    event.preventDefault()

    $('.blog__form.sticky').addClass('is-closed');
    $('.blog__form--anchor').addClass('is-closed');
  },
  closeBanner(event) {
    event.preventDefault()

    $('.promo-banner').addClass('is-closed')
    $('.header').removeClass('banner-open');
    $('.header-curtain').removeClass('banner-open');

  },
  toggleBannerOpen(event, forceClose) {
    const $banner = $('.promo-banner')
    if ( !$('.promo-banner.is-closed').length && $banner.length > 0 ) {
      if ( $(window).scrollTop() > 0 || forceClose) {
        $('.header').removeClass('banner-open');
        $('.header-curtain').removeClass('banner-open');
        $banner.addClass('is-toggling')
      } else {
        $('.header').addClass('banner-open');
        $('.header-curtain').addClass('banner-open');
        $banner.removeClass('is-toggling');
      }
    }
  },
  toggleSearchExpand(event) {
    const defaultText = $(event.currentTarget).data('placeholder');
    const expandText = $(event.currentTarget).data('placeholderexpanded');
    const currText =  $(event.currentTarget).attr('placeholder');

    if ( event.type == 'blur' ) {
      $(event.currentTarget).attr('placeholder', defaultText)
    }
    if ( event.type == 'focus' ) {
      $(event.currentTarget).attr('placeholder', expandText)
    }

  },
  handleCareersFilter(event) {
    const self = this;
    const { currentTarget } = event;
    let filters = 0

    $(`[data-location]`).each(function() {
      const location = $(this).data('location')

      if (currentTarget.checked && currentTarget.value == location) {
        if (self.careerLocations.indexOf(location) == -1) self.careerLocations.push(location)
      }
      if (!currentTarget.checked && currentTarget.value == location) {
        if (self.careerLocations.indexOf(location) != -1) {
          self.careerLocations = self.careerLocations.filter( l => l !== location)
        }
      }
      if (currentTarget.checked && currentTarget.value != location) {
        if (self.careerLocations.indexOf(location) != -1 && !$(`[type="checkbox"][value="${location}"]`).prop('checked')) {
          self.careerLocations = self.careerLocations.filter( l => l !== location)
        }
      }

    })

    $(`.filter-location [type="checkbox"]`).each(function() {
      if ($(this).prop('checked')) filters++
    })

    if (filters > 0){
      $(`[data-location]`).addClass('u-hidden-complete')
    } else {
      $(`[data-location]`).removeClass('u-hidden-complete')
    }

    self.careerLocations.forEach( (elm) => {
      $(`[data-location="${elm}"]`).removeClass('u-hidden-complete')
    } )
  },
  initCareersFilter() {
    const self = this;
    let exists = {}
    $('[data-location]').each(function() {
      const loc = $(this).data('location')
      if ( !exists[loc] ) {
        self.careerLocations.push(loc)
        exists[loc] = true
      }
    })

    self.careerLocations.forEach( (elm) => {
      const loc = elm.split()
      const columns = self.careerLocations.length < 3 ? 12 / self.careerLocations.length : 4;
      const template = `
      <li class="filter-location grid__column u-size-${columns}of12--md">
        <input type="checkbox" id="${ elm }" value="${ elm }"/><label for="${ elm }">${ loc[0] }</label>
      </li>`;

      $('.js-location-filter').append(template)
    })
  },
  sizeTimeline() {
    const $timeline = $('.js-timeline .timeline-list');
    const $timelineWrapper = $('.timeline__wrapper');
    const paddingTop = $('.building-block--timeline').css('padding-top');
    let width = 120;

    if ( $timeline.length ) {
      $timeline.find('.milestone').each(function() {
        const milestone = this;

        width = width + $(milestone).outerWidth()
      })
      width = width - 40;
      $timeline.width(width)
      $timelineWrapper.width(width)
      $timelineWrapper.height($('.building-block--timeline').outerHeight())
      $timelineWrapper.css('margin-top', `-${paddingTop}`)
    }
  },

  initPopup() {
    $('.js-team-modal').magnificPopup({
      type:'inline',
      midClick: true,
      mainClass: 'popup--animate',
      fixedContentPos: true,
      closeBtnInside: true,
    });
  },

  initSlick() {
    $('.js-testimonial-slider').slick({
      autoplay: true,
      autoplaySpeed: 5000,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      dots: true,
      adaptiveHeight: true
    });
    $('.js-thumbnails--infinite').slick({
      speed: 10000,
      autoplay: true,
      autoplaySpeed: 0,
      cssEase: 'linear',
      slidesToShow: 1,
      slidesToScroll: 1,
      variableWidth: true,
      arrows: false,
      dots: false
    });
    $('.js-slider-home').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      dots: true,
      customPaging: function(slick, index) {
        let textarea = document.createElement("textarea");
        let icon_svg = $(`[data-slick-index=${index}] [data-icon-svg]`).data('iconSvg');

        textarea.innerHTML = icon_svg;

        return `<span data-index="${index}">${textarea.value}</span>`;
      }
    });
    const $sliders = $('.js-slider-product');
    $sliders.each(function() {
      const $nav = $(this).parent().find('.js-links');
      $(this).slick({
        autoplay: true,
        autoplaySpeed: 5000,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        infinite: true,
        speed: 500,
        fade: true,
        cssEase: 'linear',
        customPaging: function(slick, index) {
          let textarea = document.createElement("textarea");
          let link = $nav.find(`[data-idx=${index}]`).html();

          textarea.innerHTML = link;

          return `<span data-index="${index}">${textarea.value}</span>`;
        }
      });
    });
    this.handleSliderExtendedFns();
  },
  handleSliderExtendedFns() {
    if ( !$('.js-slider-home').length ) return false;

    var transformPresentations = function(x) {
      x = $(window).width() > 500 ? 0 : x;

      $('.js-slider-home .slick-dots li').each(function() {

        this.style.transform = 'translate('+x+', 0)';

      })
    }

    if ( $(window).width() > 500) {
      transformPresentations(0)
    }


    $(document).on('click', '.slick-dots li svg', function() {
      const nav = $(this).closest('[data-index]');
      let idx = nav.data('index');
          idx = idx == $('.slick-dots li:last-child').find('[data-index]').data('index') ? parseInt(idx - 1) : idx;
      const x = -(idx * 100);
      const x_perc = x + '%';

      transformPresentations(x_perc)
    })

    $('.slick-prev').click(function() {
      let idx = $('.slick-active').find('[data-index]').data('index');
          idx = idx == $('.slick-dots li:last-child').find('[data-index]').data('index') ? parseInt($('.slick-dots li:last-child').find('[data-index]').data('index') - 1) : idx;

      const x = idx == 0 ? 0 : -(idx * 100);
      const x_perc = x + '%';

      transformPresentations(x_perc)
    })

    $('.slick-next').click(function() {
      let idx = $('.slick-active').find('[data-index]').data('index');

      idx = idx == $('.slick-dots li:last-child').find('[data-index]').data('index') ? parseInt(idx - 1) : idx;

      const x = idx == 0 ? 0 : -(idx * 100);
      const x_perc = x + '%';

      transformPresentations(x_perc)
    })
  },
  initStickyNav() {

    if ( $(window).scrollTop() >= 2) {
      $('.header').addClass('header--unpinned')
      document.body.style.setProperty('--headerNavHeight', $('.header').outerHeight(true) + 'px');
    } else {
      $('.header').removeClass('header--unpinned')
      document.body.style.setProperty('--headerNavHeight', $('.header').outerHeight(true) + 'px');
    }

    if ($('.sub-menu--secondary__anchor').length) {
      var window_top = $(window).scrollTop();
      var div_top = $('.sub-menu--secondary__anchor').offset().top;
      var phantomHeight = $('.sub-menu--secondary').outerHeight();

      if ( window_top > div_top ) {
        if (div_top > 0) $('.sub-menu--secondary__anchor').height(phantomHeight);
        $('.sub-menu--secondary').addClass('stick');
        $('.sub-menu--secondary').css({
          marginLeft: 0,
        });

      } else {
        $('.sub-menu--secondary__anchor').height(0);
        $('.sub-menu--secondary').css({width: ''});
        $('.sub-menu--secondary').css({
          marginLeft: '',
        });
        $('.sub-menu--secondary').removeClass('stick');

      }
    }
  },
  initHeadroom() {
    let elm = document.querySelector('.js-header.has-secondary');
    let options = {
      "offset": 205,
      "tolerance": 5
    }
    if (elm) {
      let headroom = new Headroom(elm, options);

      headroom.init();
    }
  },
  initStickyShare() {
    const $anchor = $('.share-buttons__anchor');
    const triggerWidth = ($(window).width() >= 993 );
    let { stickyFormTriggered } = this;

    if (!triggerWidth && $('.sticky').length) {
      $('.sticky').css('top', 0);
      $('.sticky').removeClass('stick');
      $('.sticky').addClass('clear-wrapper');

      return false;
    }

    if ($('.sticky').length && $anchor.length) {
      var window_top = $(window).scrollTop();
      var div_top = $anchor.offset().top;
      var phantomHeight = $('.share-buttons.blog').outerHeight();
      var phantomTop = parseInt($('.share-buttons.blog').css('top'));
      var navHeight = $('.js-header').outerHeight();
      var main_end = $('.building-block--cta').length ? $('.building-block--cta').offset().top : $('.footer').offset().top;
      var triggerPoint = !stickyFormTriggered ? window_top >= (div_top - navHeight) : window_top >= div_top;
      var easePoint = window_top >= (main_end - navHeight - phantomHeight - phantomTop);

      if ( triggerPoint ) {
        $('.sticky').addClass('stick');
        $('.sticky').removeClass('clear-wrapper');
        $('.sticky').css('top', navHeight);

        stickyFormTriggered = true;

      } else {

        $('.sticky').css('top', 0);
        $('.sticky').removeClass('stick');
        $('.sticky').addClass('clear-wrapper');

      }

      if ( easePoint ) {
        $('.sticky').addClass('sticky--ease-out');
        $('.sticky').css('margin-top', -(phantomHeight + phantomTop)+'px');
      } else {
        $('.sticky').removeClass('sticky--ease-out');
        $('.sticky').css('margin-top', 0);
      }

    }
  },
  initStickyForm() {
    const $anchor = $('.blog__form--anchor');
    let { stickyFormTriggered } = this;

    if ($('.sticky').length && $anchor.length) {
      var window_top = $(window).scrollTop();
      var div_top = $anchor.offset().top;
      var phantomHeight = $('.sticky').outerHeight();
      var navHeight = $('.js-header').outerHeight();
      var main_end = $('.building-block--cta').offset().top;
      var triggerPoint = !stickyFormTriggered ? window_top >= (div_top - navHeight) : window_top >= div_top;
      var easePoint = window_top >= (main_end - navHeight - phantomHeight);
      if ( triggerPoint ) {
        $anchor.height( phantomHeight );
        $('.sticky').addClass('stick');
        $('.sticky').css('top', navHeight);

        stickyFormTriggered = true;

      } else {

        $anchor.height( 0 );
        $('.sticky').css('top', 0);
        $('.sticky').removeClass('stick');

      }

      if ( easePoint ) {
        $('.sticky').addClass('sticky--ease-out');
        $('.sticky').css('margin-top', -phantomHeight+'px');
      } else {
        $('.sticky').removeClass('sticky--ease-out');
        $('.sticky').css('margin-top', 0);
      }

    }
  },

  handleFeatureTabsClick(e) {
    e.preventDefault();

    const itemIdx = $(e.target).data('idx');

    $('.tab-link').removeClass('is-active');
    $('.feature-tabs__img img').removeClass('is-active');
    $(e.target).addClass('is-active');

    $('.feature-tabs__img img').each(function() {
      if ( itemIdx == $(this).data('idx') ) $(this).addClass('is-active');
    })

  },
  handleProductFeatureClick(e) {
    e.preventDefault();

    const itemIdx = $(e.target).data('idx');

    $('.js-interactive-link').removeClass('is-active');
    $('.illustrations img').removeClass('is-active');
    $(e.target).addClass('is-active');

    $('.illustrations img').each(function() {
      if ( itemIdx == $(this).data('idx') ) $(this).addClass('is-active');
    })

  },
  handleSecondaryMobile(e) {
      e.preventDefault()
      $(e.currentTarget).toggleClass('dropdown-active');
      $('.sub-menu--secondary__mobile .sub-menu--secondary-inner').toggleClass('is-active')
  },
  handleMiParrow(e) {
    e.preventDefault()
    if ($(window).width() >= 960) {
      var target = $('.building-block--hero + .building-block');
      var target_top = target ? target.offset().top : null;

      if (target.length && e.target == e.currentTarget) {

        $('html,body').animate({
          scrollTop: target_top
          }, 500);
        return false;
      }
    }
  },
  resetNav(event) {
    const { target, type } = event;
    const $extendedNav = $('.sub-menu--extended');
    const $subMenus = $('.sub-menu');
    const $navItems = $('.nav--main a');
    const $extendedNavInner = $('.sub-menu--extended-inner');

    const $header = $('.header');
    const isNotNav = !$(target).closest('.is-active').length &&
                  !$(target).hasClass('sub-menu--extended') &&
                  !$(target).hasClass('sub-menu--extended-inner') &&
                  !$(target).hasClass('sub-menu') &&
                  !$(target).hasClass('sub-menu__header')&&
                  !$(target).hasClass('header-curtain') &&
                  !$(target).hasClass('header') &&
                  !$(target).closest('.menu-item').length &&
                  !$(target).is('li') &&
                  !$(target).is('ul');

    if ( type == 'click'  && isNotNav || type == 'scroll' ) {
      $navItems.removeClass('is-active');
      $extendedNav.removeClass('is-active');
      $extendedNavInner.removeClass('is-active');
      $subMenus.removeClass('is-active');
      $header.removeClass('has-open-menu');
      this.closeSubMenu()
      //$headerCuratin.css('height', '1px');
    }
    if (type == 'scroll') {
      this.$mobileNav.removeClass('is-active');
      this.$hamburger.removeClass('is-active');
      // $('.sub-menu--title a').removeClass('is-active')
      // $('.sub-menu--secondary__mobile .sub-menu--secondary-inner').removeClass('dropdown-active');
    }
  },
  createYoutubePlayer() {
    const self = this;

    self.player = new YT.Player('ytplayer', {
      videoId: self.YID,
        playerVars: {
        'controls' : 0,
        'modestbranding' : 1,
        'rel' : 0,
        'showinfo' : 0
      },
      events: {
        'onReady': self.onPlayerReady,
        'onStateChange': self.onPlayerStateChange.bind(self)
      }
    });
  },
  showVideo(event) {
    event.preventDefault();
    $('.js-video-inner').addClass('inner__active');

    if (!this.video.shown) {

      this.YID = $(event.currentTarget).data('youtube_id');

      var tag = document.createElement('script');
          tag.src = `${location.protocol}//www.youtube.com/iframe_api`;
      var script = document.getElementsByTagName('script')[0];
          script.parentNode.insertBefore(tag, script);
          this.video.shown = true;
    }

  },
  timeConverter(UNIX_timestamp){
    var a = new Date(UNIX_timestamp * 1000);
    var min = a.getMinutes();
    var sec = a.getSeconds() < 10 ? '0' + a.getSeconds() : a.getSeconds();
    var time = min + '.' + sec ;
    return time;
  },
  progress() {
    var $element = $('.js-seekbar');
    var slider = $('.seekbar__input')

    slider.val(this.video.time.playerCurrentTime);

    $element.find('div').html(this.timeConverter(this.video.time.playerCurrentTime));

  },
  onPlayerReady(event) {
    event.target.playVideo();
    var playerTotalTime = event.target.getDuration();
    var slider = $('.seekbar__input')

    $('.js-seekbar .seekbar__input').addClass('active');
    slider.attr('min', 0);
    slider.attr('max', Math.round(playerTotalTime));
  },
  onPlayerStateChange(event) {
    if (event.data == YT.PlayerState.PLAYING) {
      this.video.playing = true;
      var playerTotalTime = this.player.getDuration();
      var timeObject = {
        playerTotalTime: playerTotalTime
      }

      var vidTimer = setInterval(function() {
        var playerCurrentTime = this.player.getCurrentTime();

        timeObject.playerCurrentTime = playerCurrentTime;

        this.video.time = timeObject;

        this.progress();
      }.bind(this), 300);
    } else {
      this.video.playing = false;

      clearTimeout(vidTimer);

    }
  },
  onSeek(event){
    this.video.time.playerCurrentTime = event.target.value
    this.player.seekTo(this.video.time.playerCurrentTime)
  },
  onPlay(event) {
    var playButton = $(event.target);

    if ( playButton && this.player && !this.video.playing ) this.player.playVideo()
    if ( playButton && this.player &&  this.video.playing ) this.player.pauseVideo()
  },
  removeSubmenus() {
    const $navWithChildren = $('.menu-item-has-children');

    $navWithChildren.each(function() {
      const $navItem = $(this);

      if ( $navItem.find('.sub-menu').length && $navItem.find('.sub-menu--extended').length ) {
        $navItem.find('.sub-menu').remove()
     }

     if ( $navItem.find('.has-promo').length && !$navItem.find('.sub-menu--extended').length ) {
      $navItem.find('.sub-menu:not(.has-promo)').remove()
     }


    })

  },
  openSubMenu(e) {
    const $navItem = $(e.target).is('a') ? $(e.target).closest('.menu-item-has-children') : $(e.target);
    const $header = $('.header');

    if ( !$(e.target).is('li') && !$(e.target).is('a') ) return false

    $('.menu-item-has-children').removeClass('is-active')

    if ( $navItem.hasClass('menu-item-has-children') ) e.preventDefault();

    $navItem.addClass('is-active');
    $header.addClass('has-open-menu');

  },
  closeSubMenu(e) {
    $('.menu-item-has-children').removeClass('is-active')
  },
  openMobileNavDrawer(e) {
    const $navItem = $(e.currentTarget);
    const $navMobileInner = $('.nav--mobile__inner');
    const $navWithChildren = $navItem.closest('.menu-item-has-children');
    const $extendedMobile = $navItem.find('+ .sub-menu--extended-inner');
    const $subNav = $navItem.find('+ .sub-menu');
    const $extendedMobileNav = $extendedMobile.find('[data-menu-for]');

    if ( $navWithChildren.length ) e.preventDefault();
    if (!$extendedMobile.length) $subNav.addClass('is-active');
    // if (!$extendedMobile.length && !$subNav.find('> a').length && $navWithChildren.length)
    //   $subNav.prepend(`<a class="mobile-nav-close" href="${$navItem.attr('href')}">${$navItem.text()}</a>`)
    $extendedMobileNav.addClass('is-active');

    if(!$extendedMobile.hasClass('is-active')){
      $extendedMobile.addClass('is-active').slideDown(300);
        setTimeout(function() {
          $navWithChildren.addClass('is-active');
        }, 50);
    }else{
      $extendedMobile.removeClass('is-active').slideUp(300);
        setTimeout(function() {
          $navWithChildren.removeClass('is-active');
        }, 50);
    }
    // $navMobileInner.addClass('sliding-drawer');

    $('.nav--mobile a').not($navItem).removeClass('is-active');

    // setTimeout(function() {
    //   $navWithChildren.addClass('is-active');
    // }, 50);

    // setTimeout(function() {
    //   $navMobileInner.removeClass('sliding-drawer');
    // }, 400)

  },
  closeMobileNavDrawer(e) {
    const $subDrawerNav = $(e.currentTarget);
    const $navMobileInner = $('.nav--mobile__inner');
    const $navWithChildren = $subDrawerNav.closest('.menu-item-has-children');

    e.preventDefault();

    $navMobileInner.addClass('sliding-drawer');
    $navWithChildren.removeClass('is-active');

    $('.sub-menu--extended-inner').removeClass('is-active').slideUp(300);
    $('.sub-menu').removeClass('is-active');
    this.$mobileNav.addClass('is-active');
    this.$hamburger.addClass('is-active');
    setTimeout(function() {
      $navMobileInner.removeClass('sliding-drawer');
      $('[data-menu-for]').removeClass('is-active');
    }, 400);

  },
  showMobileNav(event) {
    event.preventDefault();
    this.$mobileNav.toggleClass('is-active');
    this.$hamburger.toggleClass('is-active');

    if ( this.$mobileNav.hasClass('is-active') ) {
      this.$hamburger.attr("aria-pressed", "true");
    } else {
      this.$hamburger.removeAttr("aria-pressed");
    }
  },
  scrollToSection(event) {
    const el = $(event.currentTarget);
    let section = el.attr('href');
    event.preventDefault();

    if (section) {
      $('html, body').animate({
        scrollTop: $(section).offset().top-80
      }, 1000);
    }
  },
  selectify() {
    window.$selects = $('body:not(.wp-admin) select:not(.select-default)');

    const options = {
      onInitialize: function() {
        this.$control_input.attr('readonly', true);
      },
      render: {
        item: function (data, escape) {
          return '<div class="item js-option" data-url="' + data.url + '" data-network="' + data.network + '">' + data.value + '</div>';
        }
      },
      onItemAdd: function(val, $item) {
        const itemURL = $item.data('url') && $item.data('url') !== 'undefined' ? $item.data('url') : null;

        if (itemURL) {

          cookie.set('become-partner-lang',
            { value: val,
              expires: cookie.expires(1)
            })

          if ( cookie.get('become-partner-lang') !== cookie.get('become-partner-lang-prev') ) {
            location.href = itemURL

            cookie.set('become-partner-lang-prev',
            { value: val,
              expires: cookie.expires(1)
            })
          }
        }
      }
    }
    window.$selects.selectize(options);

    if ($('.page-template-become-a-partner').length && cookie.get('become-partner-lang') ) {
      const $control = window.$selects[0].selectize;
      $control.addItem(cookie.get('become-partner-lang'), 1)
    }

  },
  openShareWindow(event) {
    let link = $(event.currentTarget).attr('href');
    if (link.substr(0, 6) != 'mailto') {
        event.preventDefault();
        window.open(link, '', 'width=600, height=400');
    }
  },
  handleWebinarModal(event) {
    event.preventDefault();
    var videoItem = $(event.currentTarget);
    var videoSrc = videoItem.data('video');

    $.magnificPopup.open({
      items: {
        src: videoSrc,
        type: 'iframe',
      },
      midClick: true,
      removalDelay: 100,
      mainClass: 'popup--animate',
      iframe: {
        markup: '<div class="mfp-video-header">' +
          '<div class="mfp-close"></div>' +
          '</div>' +
          '<div class="mfp-iframe-scaler">' +
          '<iframe class="mfp-iframe" frameborder="0" allowfullscreen></iframe>' +
          '</div>', // HTML markup of popup, `mfp-close` will be replaced by the close button
        patterns: {
          youtube: {
            index: 'youtube.com',
            id: 'v=',
            src: '//www.youtube.com/embed/%id%?rel=0&autoplay=1'
          }
        }
      }
    });
  },
  initAjax() {
    const { ajaxLoadMore } = this;
    let keyword = null;
    $('input[type="search"]').each(function() {
      if (this.value) {
        keyword = this.value;
      }
    })
    const cat = {
      listSel: '#cat_list',
      offset: $('#cat_list .card-ui').length,
      id: '#loadmore-category',
      optionId: '#cat_option',
      action: 'cats_ajax',
      catIdentifier: '.card-categories__item',
      pageId: $('#cat_list').data('page-id') ?? null
    }
    const search = {
      listSel: '#search_list',
      offset: $('#search_list .card-ui').length,
      id: '#loadmore-search',
      keyword,
      action: 'search_ajax'
    }
    const press = {
      listSel: '#press_list',
      offset: $('.press-grid .grid__column').length,
      id: '#loadmore-press',
      action: 'loadmore_press'
    }

    $(cat.id).on("click", (e) => { ajaxLoadMore(e, cat) });
    $(cat.catIdentifier).on("click", (e) => { ajaxLoadMore(e, cat) });
    $(press.id).on("click", (e) => { ajaxLoadMore(e, press) });
    $(search.id).on("click", (e) => { ajaxLoadMore(e, search) });
  },
  pricingUX() {
    if ( $('.minus-padding-1').length ) {
      if ( $('.pricing__cards').length )  {
        $('.pricing__cards').each(function() {
          let padding = 0;
          const $descriptions_without_text_above = $(this).find('.minus-padding-0');

          $(this).find('.minus-padding-1').each(function() {
            let infoHeight = $(this).siblings('.pricing__card--sm-info').eq(0).height();
            let paddingTop = $(this).css('padding-top');

            padding = parseInt(infoHeight) > padding ? parseInt(infoHeight) : padding;

            $descriptions_without_text_above.css('padding-top', padding + parseInt(paddingTop) );

          })
        })
      }
    }
  },
  initSliderIosPage() {
    let ios_rc_posts_slider_el = $('.ios-rc-posts-slider-module__posts-slider.js-slider-init');
    let ios_rc_posts_slider_el_mobile = $('.ios-rc-posts-slider-module__posts-slider .js-slider-init-mobile');

    const slider_settings = {
      dots: true,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1
    }

    const slider_settings_mobile = {
      dots: true,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1
    }

    if (ios_rc_posts_slider_el.length > 0) {
      ios_rc_posts_slider_el.slick(slider_settings);
    }

    if (ios_rc_posts_slider_el_mobile.length > 0) {
      ios_rc_posts_slider_el_mobile.slick(slider_settings_mobile);
    }
  },
  ajaxLoadMore (e, obj) {

    let { optionId, offset, action, id, listSel } = obj;
    let pageCategory;
    if (optionId) {
      pageCategory = document.querySelector(optionId).getAttribute('data-value') ?? null;
    }
    let category = optionId ? pageCategory : null;
    let adminAjaxUrl = jQuery('#adminAjaxUrl').val();
    let data = { category, offset, action }

    let cat_item = e.target.className.trim().split(" ") ?? [];
    let is_it_category_click = "card-categories__item" == cat_item[0] ? true : false;
    // let elementClasses = e.target.classList;
    // let is_it_category_click = elementClasses.contains("card-categories__item") ? true : false;
    // let is_it_active_active_category_click = elementClasses.contains("active") ? true : false;
    if(is_it_category_click) {
      data.category = e.target.getAttribute('data-catid') ?? category;
      // if (is_it_active_active_category_click) {
      //   data.category = pageCategory;
      // }
      $(optionId).attr('data-value',data.category);
      let cardsHolderNode = document.querySelector('#cat_list');
      cardsHolderNode.setAttribute('data-paged', 1);
      while (cardsHolderNode.lastElementChild) {
          cardsHolderNode.removeChild(cardsHolderNode.lastElementChild);
      }
    }

    e.stopPropagation();

    data.curr_page =  $(listSel).attr('data-paged') ? $(listSel).attr('data-paged') : 1;
    data.card_type =  $(listSel).attr('data-cardtype') ? $(listSel).attr('data-cardtype') : "search";
    data.wild_card_sequence = $(listSel).attr('data-wild-card-sequence') ? $(listSel).attr('data-wild-card-sequence') : 4;

    let new_wild_card_sequence;
    if ("blog" == $(listSel).attr('data-cardtype') || "press" == $(listSel).attr('data-cardtype') || "skadnetwork" == $(listSel).attr('data-cardtype')) {
        new_wild_card_sequence = data.wild_card_sequence == 6 ? 4 : 6;
        $(listSel).attr('data-wild-card-sequence', new_wild_card_sequence);
    }

    if ("customer-stories" == $(listSel).attr('data-cardtype')) {
        data.wild_card2_sequence = $(listSel).attr('data-wild-card-sequence2') ? $(listSel).attr('data-wild-card-sequence2') : 10;
        data.page_id = obj.pageId;
    }

    if ("search" == $(listSel).attr('data-cardtype')) {
        if(!$(id).length) {
           id = '#loadmore-search';
        }
        data.offset = 9;
    }

    if ( !is_it_category_click && data.curr_page >= 1) {
        data.curr_page++
    }

    if (obj.keyword) data.keyword = obj.keyword

    $(listSel).attr('data-paged', data.curr_page);

    jQuery.ajax({
      url: adminAjaxUrl,
      type: 'POST',
      data,
      beforeSend:function(xhr){
        $('#ajax-loading').show();
        $(id).hide();
      },
      success: function(data){
        $('#ajax-loading').hide();
        var $data = $(data);

        if ($data.length) {
          $(listSel).append($data);
          if($data.length < 9) {
            $(id).hide();
          } else {
            $(id).show();
          }
        } else {
          $(id).hide();
        }
      }
    });

    offset += 6;
    return false;
  },
  triggerPdfPownload() {
    const link = document.createElement('a');
    const pdflink = $('.download-pdf').data('pdf');
    let pdfName = $('.download-pdf').data('pdfname') ? $('.download-pdf').data('pdfname') : 'Singular-Report.pdf';
        pdfName = pdfName.length && pdfName.slice(-4) !== '.pdf' ? `${pdfName}.pdf` : pdfName;
    link.href = pdflink;
    link.download = pdfName;
    link.dispatchEvent(new MouseEvent('click'));
    link.remove();
  },
  reportMenuScroll() {
    var menuFloat = document.querySelector('.report-page__menu__wrap');
    var footer = document.querySelector('.footer');
    function checkOffset() {
      function getRectTop(el){
        var rect = el.getBoundingClientRect();
        return rect.top;
      }
      if((getRectTop(menuFloat) + document.body.scrollTop) + menuFloat.offsetHeight >= (getRectTop(footer) + document.body.scrollTop) - 10)
        menuFloat.style.position = 'absolute';
      if(document.body.scrollTop + window.innerHeight < (getRectTop(footer) + document.body.scrollTop))
        menuFloat.style.position = 'fixed';
    }
    document.addEventListener("scroll", function(){
      checkOffset();
    });
  },
  toggleSeeMoreMatrix() {
    $('.js-overflow-group').toggleClass('hide-group')
    $('.pricing__matrix--toggle').toggleClass('is-open')
  },
  openLinksInNewWindow(event) {
    const { target } = event;
    if (target && target.href.length > 1) {
      event.preventDefault();

      let windowOpen = window.open();
      windowOpen.opener = null;
      windowOpen.location = target.protocol + '//' + target.host + '' + target.pathname;
    }
  },
  setPricingPageCtaParams() {
    /* Debug enabled with ?debug_logger=true */
    const DEBUG = new URLSearchParams(window.location.search)
      .get('debug_logger') === 'true';

    function debugLog(message, data) {
      if (!DEBUG) return;

      if (typeof data === 'undefined') {
        console.log('[Pricing Page CTA Params] ' + message);
      } else {
        console.log('[Pricing Page CTA Params] ' + message, data);
      }
    }

    /* Cookiebot marketing consent */
    function hasMarketingConsent() {
      return !!(
        window.Cookiebot &&
        window.Cookiebot.consent &&
        window.Cookiebot.consent.marketing === true
      );
    }

    /* Check consent before accessing attribution cookies */
    const marketingConsent = hasMarketingConsent();

    debugLog('Cookie consent status', {
      cookiebotLoaded: !!window.Cookiebot,
      marketingConsent: marketingConsent,
      scriptWillExecute: marketingConsent
    });

    if (!marketingConsent) {
      debugLog('Execution blocked: marketing consent not granted.');
      return;
    }

    /* Read attribution cookie safely */
    let utm_params = {};

    try {
      const cookieValue = cookie.get('utmParamsJson');

      if (!cookieValue) {
        debugLog('utmParamsJson cookie not found.');
        return;
      }

      utm_params = JSON.parse(decodeURIComponent(cookieValue));

      if (
        !utm_params ||
        typeof utm_params !== 'object' ||
        Array.isArray(utm_params)
      ) {
        debugLog('Invalid cookie data.');
        return;
      }

    } catch (error) {
      debugLog('Failed to parse attribution cookie.', error);
      return;
    }

    /* Find relevant CTA links */
    const CTAs = document.querySelectorAll(
      '.nav--main__right a, .button'
    );

    let updatedLinks = 0;

    CTAs.forEach(element => {
      const url = element.href || '';

      if (!url) return;

      let newUrl;

      try {
        newUrl = new URL(url, window.location.href);
      } catch (error) {
        return;
      }

      /* Check eligible CTA destinations */
      const isAppLink =
        newUrl.hostname === 'app.singular.net';

      const isDemoCTA =
        newUrl.searchParams.get('cta') === 'demo';

      const isPricingCTA =
        newUrl.searchParams.has('view_pricing');

      if (!isAppLink && !isDemoCTA && !isPricingCTA) {
        return;
      }

      let changed = false;

      Object.keys(utm_params).forEach(param => {
        const value = utm_params[param];

        if (
          value === null ||
          typeof value === 'undefined' ||
          value === ''
        ) {
          return;
        }

        /* Preserve existing CTA URL parameters */
        if (!newUrl.searchParams.has(param)) {
          newUrl.searchParams.set(param, String(value));
          changed = true;
        }
      });

      if (changed) {
        element.href = newUrl.toString();
        updatedLinks++;
      }
    });

    debugLog('CTA parameter forwarding completed.', {
      updatedLinks: updatedLinks,
      utmParams: utm_params
    });
  },
  setHubSpotFormCountryDd() {
    const IPINFO_URL = "https://ipinfo.io/json";
    window.addEventListener('message', function (event) {

      // Code to run after form has been inserted to DOM
      if (event.data.type === 'hsFormCallback' && event.data.eventName === 'onFormReady') {

        // Populate Country
          async function populate_country() {
              const hasCountryDdl = document.querySelector('select[name=country_c]') || false;
              if (!hasCountryDdl) {
                  return;
              }

              const response = await fetch(IPINFO_URL);
              let data = await response.json();
              const countryName = new Intl.DisplayNames(['en'], {type: 'region'});
              hasCountryDdl.value = countryName.of(data.country);

              // Region based personalization
              if (countryName.of(data.country) == "China" || location.pathname.startsWith("/zh-cn")) {
                  let hideCountries = hasCountryDdl.querySelectorAll("option[value='Hong Kong'], option[value='Taiwan']") ?? false;
                  if(hideCountries) {
                      hideCountries.forEach((hideCountry) => hideCountry.style.display = "none");
                  }
              }
          }

          populate_country();
      }
    });

  },
  customEmailValidationHubSpot() {

    // Custom email validation function
    const validateEmail = function (email) {
        return /\@(?!(wir-haben-nachwuchs|mail|login-email|tutanota|tyldd|20minutemail|blockfilter|mailme|wilemail|disposableaddress|noref|myemailboxy|20mail|stop-my-spam|20mail|wirsindcool|lortemail|anonbox|mail15|antispam24|30minutesmail|inbox|get2mail|mycleaninbox|login-email|pimpedupmyspace|spamsalad|email-fake|netzidiot|fakeinformation|guerrillamail|freemails|mbx|mailfree|one-time|burstmail|tradermail|ahk|ikbenspamvrij|get1mail|3mail|inmail24|stop-my-spam|mailforspam|mailbucket|die-optimisten|spambog|selfdestructingmail|hotpop|mailinator|spamfighter|baldpapa|grandmasmail|10minutemail|lazyinbox|trash2009|qisdo|ag|21cn|dumpyemail|fastsubaru|spambog|clixser|uk2|fastkawasaki|deadfake|fux0ringduh|einrot|getairmail|10mail|xsecurity|gowikicars|yep|getairmail|cheatmail|gotti|123-m|0sg|uroid|tittbit|portsaid|oneoffmail|jnxjn|digital-filestore|nospamfor|moakt|dyndns|turboprinzessin|brennendesreich|shared-files|spambog|amail|fakemailgenerator|TempEmail|herp|keepmymail|chammy|mailjunk|mail333|devnullmail|wegwerf-emails|mailexpire|snkmail|emailthe|consumerriot|guerillamail|shieldedmail|download-privat|ich-bin-verrueckt-nach-dir|hab-verschlafen|fightallspam|hartbot|trashmail|centermail|gelitik|herr-der-mails|tempemail|qq|droplar|yopmail|dingbone|ieatspam|mailcatch|spameater|a-bc|trashmailer|fakeinbox|mytemp|spambog|jsrsolutions|spamherelots|boxformail|wegwerfadresse|mfsa|mailinblack|dumpmail|fakeinbox|broadbandninja|gowikitv|mt2014|yopmail|snakemail|trash-mail|kommespaeter|mailinator|free-email|nospam4|streber24|mailmate|mailincubator|kulturbetrieb|docmail|afrobacon|boun|cust|goldtoolbox|sinnlos-mail|abyssmail|emailage|mt2009|landmail|junkmail|otherinbox|yapped|punkass|emailage|bouncr|bsnow|emkei|tempinbox|radiku|75hosting|onewaymail|trash-mail|7tags|6mail|lr7|spaml|webm4il|mailguard|getonemail|facebook-email|6mail|dating4best|garliclife|nervtmich|adverity|hellodream|emailproxsy|mailueberfall|centermail|public-files|mjukglass|ce|za|wollan|incognitomail|wegwerfmail|skeefmail|7mail|s0ny|drdrb|emailtaxi|courriel|maildrop|showslow|recode|kinglibrary|spammote|privymail|mailcatch|meltmail|sofimail|klassmaster|spamtroll|inbax|MailScrap|walkmail|doiea|50e|wegwerfemail|sweetville|schreib-doch-mal-wieder|temporarioemail|get-mail|turboprinz|spamreturn|gowikigames|meine-urlaubsfotos|smashmail|listomail|inboxalias|mypacks|ist-einmalig|migumail|bofthew|spamcowboy|spambob|amorki|my10minutemail|siria|branch|antichef|women-at-work|xmail|trash-mail|zomg|super-auswahl|etranquil|tempemail|www|discard|binkmail|lastmail|2prong|get-mail|beddly|spam|hot-mail|satka|spamoff|wormseo|kingsq|jetable|test|throwawayemailaddress|sags-per-mail|maileater|spambox|qv7|ieatspam|ms9|prtnx|mailnesia|fishfuse|mailrock|killmail|big1|disposableemailaddresses|email60|guerrillamail|ist-allein|imails|emailias|10minutemail|mezimages|weinenvorglueck|nervmich|ich-will-net|klzlk|jetable|instant-mail|10minutemail|datorama|hot-mail|fansworldwide|xmaily|nobulk|dayrep|mailfree|rejectmail|tempymail|cmail|mail|bspamfree|monumentmail|whtjddn|rk9|objectmail|maboard|nomorespamemails|ac20mail|guerrillamail|unmail|emailspam|pornobilder-mal-gratis|manifestgenerator|despammed|golfilla|sogetthis|trash2010|mailme24|hidzz|75hosting|choicemail1|blogmyway|kimsdisk|deadspam|loadby|killmail|partybombe|polizisten-duzer|tempomail|yeah|tempthe|crazespaces|despam|lr78|yesey|notsharingmy|dealja|mail114|lroid|emailage|reallymymail|sibmail|ghosttexter|grr|vorsicht-bissig|deadchildren|33mail|mailcat|wegwerfmail|beefmilk|hmamail|vinbazar|a45|nomail2me|smellfear|emailz|bigprofessor|emailtemporar|startkeys|enterto|trillianpro|mns|trashbox|fr33mail|dm|tortenboxer|neomailbox|1zhuan|discard|www|owlpic|lags|stop-my-spam|spamobox|fizmail|brokenvalve|kochava|gawab|mypartyclip|supergreatmail|getmails|lastmail|gentlemansclub|spambooger|lookugly|acentri|getonemail|disposableinbox|gowikifilms|spamfree24|m4ilweb|skeefmail|kasmail|spamfighter|wwwnew|1chuan|kurzepost|qisoa|7mail|put2|schmusemail|quantentunnel|ajaxapp|domozmail|spamcowboy|rklips|tune|nybella|1pad|trashymail|tempemail|mailfs|8mail|0815|9mail|mail|e4ward|girlsundertheinfluence|junkmail|maildrop|fastchrysler|hidemail|get-mail|trash-mail|tempmail|9ox|wmail|lackmail|fakemail|mailscrap|sweetxxx|myspaceinc|alphafrau|trbvm|rmqkr|mufmail|stinkefinger|trickmail|xoxy|twoweirdtricks|freudenkinder|mailinater|spambox|bin-wieder-da|lifebyfood|spambob|luv2|greensloth|stop-my-spam|dcemail|inboxclean|mailjunk|centermail|gishpuppy|hasoffers|4warding|funnel|mailmetrash|c2|coldemail|siteposter|6mail|sendspamhere|getairmail|mytrashmail|temporaryinbox|imstations|terminverpennt|getairmail|incognitomail|rootprompt|tempmaildemo|myphantomemail|emailgo|humn|nowhere|xyzfree|emailz|safersignup|spamfighter|shitmail|proxymail|makemetheking|yomail|iroid|mynetstore|emailwarden|fakeinbox|emailisvalid|e-mail|mx0|SmellFear|spamavert|paplease|trashdevil|alivance|guerrillamail|front14|mintemail|salesforce|xemaps|habmalnefrage|tmail|maennerversteherin|tilien|kir|monemail|emails|675hosting|outlook|spoofmail|webuser|throwawaymail|scatmail|bumpymail|DingBone|discard|raubtierbaendiger|fake-mail|flurred|rtrtr|tempsky|mailslapping|viditag|spamfree24|bootybay|shitware|cuvox|whatsaas|spammuffel|bund|link2mail|chong-mail|email-fake|4mail|messagebeamer|haltospam|spaminator|no-spam|temp-mail|discard|guerillamail|6paq|discardmail|spamgourmet|trimix|mailslite|emailinfive|solvemail|farifluset|flyspam|mailinator|armyspy|gotmail|digitalsanctuary|spamcannon|mailshell|disposable-email|neue-dateien|azmeil|gowikinetwork|spamday|verlass-mich-nicht|spam-be-gone|manybrain|letthemeatspam|war-im-urlaub|mciek|stop-my-spam|zippymail|schafmail|pleasedontsendmespam|whopy|spamthisplease|xents|trash-mail|ralib|ephemail|get-mail|ystea|protonmail|hush|emailspam|receiveee|zoaxe|die-optimisten|fastsuzuki|hot-mail|abusemail|ruffrey|hacccc|selfdestructingmail|fdfdsfds|privy-mail|aver|toiea|bladesmail|spamcon|spikio|mailtothis|teleworm|emailspam|shinedyoureyes|casualdx|trayna|emailspam|goemailgo|mailfa|thecloudindex|emailigo|gsrv|spambox|wolke7|mailzilla|zehnminutenmail|unterderbruecke|webmail4u|gowikicampus|disposable|0815|dontsendmespam|wee|inbox2|talkinator|umail|spam|shiftmail|vollbio|anonymbox|home|burnthespam|appixie|email-fake|trashmail|oikrach|duskmail|falseaddress|mailjunk|correo|slaskpost|sriaus|ssoia|sneakemail|mailjunk|instantemailaddress|bugmenot|netterchef|explodemail|kuh|email|emailage|regbypass|naver|oopi|hushmail|meine-diashow|weibsvolk|spamgourmet|mailnull|fornow|uplipht|yandex|baldmama|spaml|tempe-mail|mailpick|disposemail|inboxclean|spamkill|oneoffemail|amiriindustries|opayq|BeefMilk|hochsitze|abcdefghijklmnopqrstuvwxyzabcdefghijklmnopqrstuvwxyzabcdefghijk|loveyouforever|nur-fuer-spam|free-email|trashmail|anappthat|spammotel|receiveee|chogmail|fivetran|noclickemail|disposableemailaddresses|crapmail|recursor|pfui|outlawspam|nospam|dharmatel|cubiclink|5mail|deadfake|viewcastmedia|nogmailspam|spambob|venompen|dump-email|spam4|login-email|mailproxsy|emailtemporario|quickmail|acquired|qasti|sperke|freemails|zxcvbnm|kaffeeschluerfer|ukr|email4u|discardmail|freundin|0-mail|soisz|ipoo|alpenjodel|thankyou2010|trash-mail|liebt-dich|mailfreeonline|guerrillamail|fahr-zur-hoelle|mail4u|great-host|email-fake|kook|talend|sharedmailbox|irish2me|eyepaste|buffemail|cashette|emkei|yzbid|safetypost|whyspam|toomail|squizzy|emkei|freemails|whatiaas|footard|directbox|bluebottle|tagesmail|sonnenkinder|tmailinator|improvado|fastmitsubishi|emaildienst|emailtemporanea|disposeamail|feinripptraeger|cghost|temporaryemail|trash2011|harakirimail|appsflyer|trash-amil|antichef|ordinaryamerican|teleworm|wuzup|ypmail|izmail|superstachel|wickmail|vidchart|emil|boxtemp|myspacepimpedup|gowikimusic|bonbon|pancakemail|ourklips|pcusers|guerillamail|filzmail|tryalert|ihateyoualot|discartmail|suremail|royal|anonymail|mailinator|1ce|slushmail|LookUgly|xoxox|deadaddress|bleib-bei-mir|dogit|insorg-mail|lopl|mail4days|dotmsg|hot-mail|litedrop|stuffmail|drdrb|jetfix|trashmail|fiifke|uggsrock|trashmail|koszmail|ubismail|obobbo|youmail|dispose|mailjunk|75hosting|fakeinbox|postacin|mobileninja|emailsensei|chong-mail|tempalias|10minutemail|spameater|cmail|deadfake|hatespam|bu|disposable|dandikmail|prtz|monmail|mymailoasis|eelmail|nowmymail|emkei|wronghead|evopo|guerillamail|dfgh|emeil|fastchevy|mail|online|bio-muesli|emeil|emailspam|spamcowboy|brefmail|wetrainbayarea|mailin8r|teewars|einrot|spamstack|soodonims|meine-fotos|pepbot|frapmail|emailage|myspaceinc|emz|lass-es-geschehen|xagloo|spamthis|privacy|dodgit|protonmail|30minutemail|mailinator|die-genossen|facebook-email|tafmail|quickinbox|spamgourmet|www|notmailinator|viewcastmedia|spamfree24|yopweb|buerotiger|saeuferleber|eintagsmail|spamcero|dieMailbox|6url|office-dateien|chong-mail|hotmail|iheartspam|spamfree24|nwldx|fakemailz|fakeinbox|friendlymail|iwi|mailismagic|ano-mail|webemail|labetteraverouge|zweb|tempmailer|mail-temporaire|slave-auctions|baxomale|pookmail|pisem|dropmail|amilegit|8mail|jobbikszimpatizans|spamcannon|whatpaas|spamgrube|mytop-in|superrito|wegwerfmail|centermail|icloud|tempail|wetrainbayarea|temp|junkmail|etranquil|lovemeleaveme|remail|inboxproxy|0wnd|mohmal|1mail|mailblocks|weibsvolk|klassmaster|odaymail|cosmorph|e-mail|wegwerpmailadres|youmailr|fuckingduh|brokenvalve|wegwerfemail|mailzilla|safetymail|l33r|trashmail|12minutemail|mail-filter|fammix|mailme|bigstring|mailquack|jn-club|mailtrash|facebookmail|zoemail|675hosting|test|maildrop|center-mail|maildrop|10minutemail|jetable|bigmir|8mail|cellurl|partyheld|spamgoes|tapchicuoihoi|zxcv|freemail|meine-dateien|trashdevil|ballyfinance|donemail|0wnd|getairmail|spamtrail|fantasymail|mega|zzz|ist-willig|buy-24h|dodgeit|lhsdv|vubby|mailbidon|mytempemail|inerted|die-besten-bilder|myadult|fastyamaha|thisisnotmyrealemail|courrieltemporaire|weg-werf-email|3126|60minutemail|netmails|jetable|buyusedlibrarybooks|centermail|guerrillamailblock|wh4f|maennerversteherin|h8s|mailme|pjjkp|zoemail|amiri|postfach|dodgit|mailimate|tagyourself|dumpandjunk|briefemail|ee2|yuurok|softpls|bobmail|vorsicht-scharf|dbunker|turual|deadfake|wegwerf-email-addressen|adjust|10minutemail|gorillaswithdirtyarmpits|forgetmail|yahoo|kaffeeschluerfer|getairmail|gowikitravel|username|emailtmp|spamify|politikerclub|nonspammer|zoemail|phreaker|sofortmail|nepwk|muskelshirt|7days-printing|prydirect|walala|ieh-mail|slopsbox|yert|soodomail|nonspam|gowikibooks|gold-profits|discardmail|nomail|mytrashmail|pwrby|emailx|dontsentmespam|spamhole|ovpn|grandmamail|mailtemp|senseless-entertainment|spamslicer|emailz|hot-mail|antispam|aol|emailz|gotmail|dispostable|hopemail|spamex|deagot|wegwerfmail|duam|addcom|smellrear|abwesend|bio-muesli|volloeko|mail4trash|valemail|dacoolest|mail2rss|jetzt-bin-ich-dran|fudgerub|krim|emailto|emaillime|thanksnospam|willselfdestruct|trash-mail|daintly|mail|mymail-in|discard|nurfuerspam|jetable|fake-mail|curryworld|viewcastmedia|mailsiphon|tempemail|discard|trashymail|twinmail|zetmail|pryworld|regbypass|will-hier-weg|veryrealemail|disposable|dumpmail|netmails|emailxfer|lol|cyber-matrix|fatflap|rcpt|shitmail|temporaryemail|FudgeRub|chongsoft|fromru|topmail-files|meinspamschutz|plexolan|email-fake|svk|shortmail|sharklasers|rppkn|gamil|gmail|gmil|gmeil|gmsil|ntlhelp|jourrapide|gotmail|guerrillamail|sofort-mail|metaping|mailzilla|sms|spamdecoy|dudmail|agnitumhost|centermail|poczta|cbair|4warding|wbb3|spambog|ist-ganz-allein|spamfree24|fettabernett|divermail|coole-files|temp-mail|cool|upliftnow|freemeilaadressforall|putthisinyourspamdatabase|incognitomail|dontreg|orangatango|spamhereplease|crazymailing|nospam|facebookmail|cmail|reconmail|0clickemail|trashmail|mobi|record|h|msa|mierdamail|6ip|spamcorptastic|fastacura|mailseal|fastmazda|yogamaven|mailfree|12hourmail|675hosting|hulapla|spamfree24|4warding|myspamless|poofy|mailnator|live|tempinbox|recyclemail|temporaryforwarding|maildrop|emailmiser|safe-mail|nospammail|spamspot|24hourmail|example|nospamthanks|temp|my-mail|trashemail|thepryam|supermailer|fixmail|myspaceinc|mailinator2|mail|moncourrier|advantimo|3d-painting|gustr|winemaven|cachedot|maildx|junk1e|4mail|fasttoyota|nus|nice-4u|fleckens|etranquil|easytrashmail|trash-mail|neverbox|msh|login-email|sohu|mailmoat|kaspop|emkei|fake-mail|tempmail2|nmail|willhackforfood|wir-sind-cool|facebook-email|rhyta|mamber|fastnissan|temporarily|imgof|totalmail|asdasd|bundes-li|spamfree|remail|moburl|nullbox|autosfromus|wuzupmail|sandelf|vomoto|yopmail|agedmail|mailsac|99experts|spamfighter|streetwisemail|throam|5mail|betriebsdirektor|speed|yopmail|spamfighter|bodhi|saynotospams|163|web|hanmail|btinternet|gmx|me|msn|gmaill|gemil|gail|eamil|besttempmail|gmali|gmel|hormail|icoud|aim|gmiil||gmai|gmial|work|gmal|g-mail|gmapil|planetfreevpn|ivloud|gmapil|ymail|gimal|gmqil|gmmail|gmwil|workemail|4gmli|gimal|gmli|gmaile)\.)/.test(email.toLowerCase());
    }

    function customEmailValidation() {

      const emailField = document.querySelector('.hbspt-form input[name="email"]') ?? false;

      // Skip if we don't have an email field
      if (!emailField) {
        return;
      }

      const submitButton = document.querySelector('.hbspt-form input[type=submit]');

      // Listen/check email field typing/change event
      emailField.addEventListener("input", (event) => {

          // If email id is invalid,
          // 1) Add red border on email field
          // 2) Disable the form submit button
          if (!validateEmail(event.target.value)) {
              emailField.style.borderColor = "red";
              submitButton.disabled = true;
              submitButton.style.backgroundColor = "gray";
          } else {
              emailField.style.borderColor = "";
              submitButton.disabled = false;
              submitButton.style.backgroundColor = "";
          }

      });

    }

    // Listen for HubSpot events
    window.addEventListener('message', function (event) {

        // Run the code after the form is loaded on the page
        if (event.data.type === 'hsFormCallback' && event.data.eventName === 'onFormReady') {

            customEmailValidation();

        }
    })

  },
  forwardApprovedUrlParams() {
    const ALLOWED_PARAMS = [
      'utm_source',
      'utm_medium',
      'utm_campaign',
      'utm_content',
      'utm_term',
      'utm_adgroup'
    ];

    const currentParams = new URLSearchParams(
      window.location.search
    );

    const DEBUG = currentParams.get('debug_logger') === 'true';

    const debugLog = (message, data) => {
      if (!DEBUG) return;

      const prefix = '[Singular URL Forwarding]';

      if (data === undefined) {
        console.log(`${prefix} ${message}`);
      } else {
        console.log(`${prefix} ${message}`, data);
      }
    };

    /**
     * Allow singular.net and all subdomains.
     */
    const isSingularDomain = hostname => {
      const host = hostname.toLowerCase();

      return (
        host === 'singular.net' ||
        host.endsWith('.singular.net')
      );
    };

    const getSourcePage = () => {
      const path = window.location.pathname;

      return path === '/'
      ? 'homepage'
      : path.replace(/^\/+|\/+$/g, '');
    };

    const sourcePage = getSourcePage();

    /* Capture only approved parameters from the current URL */
    const campaignParams = new Map();

    ALLOWED_PARAMS.forEach(param => {
      const value = currentParams.get(param);

      if (
        value !== null &&
        value !== '' &&
        value.length <= 150 &&
        !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)
      ) {
        campaignParams.set(param, value);
      }
    });

    /* Decorate a single eligible link */
    const decorateLink = link => {
      const href = link.getAttribute('href');

      if (!href || href.startsWith('#')) {
        return 'skipped';
      }

      if (link.hasAttribute('download')) {
        return 'skipped';
      }

      let url;

      try {
        url = new URL(href, window.location.href);
      } catch (error) {
        debugLog('Invalid URL skipped', href);
        return 'skipped';
      }

      if (
        !['http:', 'https:'].includes(url.protocol) ||
        !isSingularDomain(url.hostname)
      ) {
        return 'skipped';
      }

      const originalUrl = url.toString();
      let changed = false;

      /**
       * Forward whitelisted UTM parameters.
       * Current-page UTMs take precedence.
       */
      campaignParams.forEach((value, key) => {
        if (
          url.searchParams.get(key) !== value ||
          url.searchParams.getAll(key).length > 1
        ) {
          url.searchParams.set(key, value);
          changed = true;
        }
      });

      /* Always set immediate source page */
      if (
        url.searchParams.get('source_page') !== sourcePage ||
        url.searchParams.getAll('source_page').length > 1
      ) {
        url.searchParams.set('source_page', sourcePage);
        changed = true;
      }

      if (!changed) {
        return 'unchanged';
      }

      link.setAttribute('href', url.toString());

      debugLog('Link decorated', {
        before: originalUrl,
        after: url.toString(),
        sourcePage
      });

      return 'updated';
    };

    /* Scan all existing links */
    const decorateLinks = () => {
      const links = document.querySelectorAll('a[href]');

      const stats = {
        total: links.length,
        updated: 0,
        unchanged: 0,
        skipped: 0
      };

      links.forEach(link => {
        const result = decorateLink(link);
        stats[result]++;
      });

      debugLog('Decoration completed', {
        ...stats,
        sourcePage,
        forwardedParams: Object.fromEntries(campaignParams)
      });
    };

    decorateLinks();

  }
};

Mangrove.init();
window.onYouTubeIframeAPIReady = function() {
  Mangrove.createYoutubePlayer();
}
